<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex sm6 xs12 md6 lg3 @click="$router.push('/user-list')">
        <material-stats-card
          color="green"
          icon="mdi-account-group"
          title="用户"
          :value="`${summary.userCount}`"
          small-value="人"
          sub-icon="mdi-account-multiple-plus"
          :sub-text="`今天新增：${summary.userCountToday} 人`"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3 @click="$router.push('/book-list')">
        <material-stats-card
          color="red"
          icon="mdi-book-open-variant"
          title="漂流图书"
          :value="`${summary.bookCount}`"
          small-value="本"
          sub-icon="mdi-cancel"
          :sub-text="`暂停漂流：${summary.disabledBookCount} 本`"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3 @click="$router.push('/link-list')">
        <material-stats-card
          color="orange"
          icon="mdi-link-variant"
          title="漂流链"
          :value="`${summary.linkCount}`"
          small-value="条"
          sub-icon="mdi-link-plus"
          :sub-text="`今天新增：${summary.linkCountToday} 条`"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3 @click="$router.push('/comment-list')">
        <material-stats-card
          color="info"
          icon="mdi-comment-multiple"
          title="评论"
          :value="`${summary.commentCount}`"
          small-value="条"
          sub-icon="mdi-comment-plus"
          :sub-text="`今天新增：${summary.commentCountToday} 条`"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { getSummary } from '@/services'

export default {
  data() {
    return {
      summary: {
        bookCount: 0,
        disabledBookCount: 0,
        linkCount: 0,
        linkCountToday: 0,
        userCount: 0,
        userCountToday: 0,
        commentCount: 0,
        commentCountToday: 0
      }
    }
  },

  async beforeMount() {
    await this.fetchData()
  },

  methods: {
    async fetchData() {
      this.summary = await getSummary()
    }
  }
}
</script>
